import {useState} from 'react'
import {cookies_string} from '../config.js'
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { Login } from '../actions/actions'
import { loginWithPassword } from '../services/request.service'
import AquilaLogoSvg from '../svgs/AquilaLogoSvg'
import LoginPageBgSvg from '../svgs/LoginPageBgSvg.js';
import Lottie from 'react-lottie'
import StartBtnSvg from '../svgs/StartBtnSvg';
import LoginStartBtnSvg from '../svgs/LoginStartBtnSvg.js';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../lottie/kv.json'),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

function Component(props){
    const [password,setPassword]=useState('')
    const [password_err, setPassword_err] = useState('');
    const [username,setUsername]=useState('')
    const [username_err, setUsername_err] = useState('');
    const [cookies, setCookie, removeCookie] = useCookies([`@${cookies_string}_cred`,`@${cookies_string}_token`]);

    const [hasStarted,setHasStarted]=useState(false);


    const handleLogin=async ()=>{

        let isErr=false

        if(password.length<5||password===''){
            setPassword_err('Min. 5 characters.');
            isErr=true
        }else setPassword_err('')
        if(username.length<5||username===''){
            setUsername_err('Min. 5 characters.');
            isErr=true
        }else setUsername_err('')
        if(isErr)return
        let response =await loginWithPassword(username,password);

        if((!response)||response?.errno===20003){
          setPassword_err('Invalid.');
          return
        }else if(!response||response.errno){
          alert(response.message||'Unknown error!')
          return
        }else {
          const token=response?.result?.insertedId
          const usertype='client'
        
          props.dispatch(Login(true,token,usertype,username))
          setCookie(`@${cookies_string}_cred`, {username,password,usertype}, { path: '/' });
          setCookie(`@${cookies_string}_token`, token, { path: '/', maxAge:172800});
        }
      }

    const keyPressPWD=(e)=>{if (e.keyCode === 13) { handleLogin(); }}
    return(
        <div className='noselect' style={{width:"100svw",height:'100svh',boxSizing:'border-box',backgroundColor:'black',display:'flex',justifyContent:"center",alignItems:'center',overflow:'hidden'}}>
            <div style={{position:'relative',width:` min( 100svh / 1080 * 1920, 100svw)`,height:undefined,aspectRatio: 1920/1080,display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',backgroundColor:'rgb(212,212,212)',boxSizing:'border-box',overflow:'hidden'}}>
                <Lottie options={defaultOptions} loop={true} autoplay={true} style={{width:'100%',height:'100%'}} />
                {/* <div style={{position:'absolute',left:'9%',top:'45%'}}>
                    <img src='/bg.png' style={{width:' min( 80svh / 1080 * 1920, 80svw)'}}/>
                </div> */}
                <div style={{position:'absolute',right:'19%',bottom:'30%',fontSize:'min( 3svh / 1080 * 1920, 3svw)',fontWeight:900}}>
                    PART 2
                </div>
                <div onClick={()=>{setHasStarted(true)}} style={{position:'absolute',bottom:'18%',cursor:'pointer'}}>
                    <LoginStartBtnSvg width='min( 15svh / 1080 * 1920, 15svw)'/>
                </div>

                {hasStarted&&<div style={{position:'absolute',top:0,bottom:0,left:0,right:0,display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'#00000040'}}>
                    <div style={{position:'absolute',backgroundColor:'white',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',padding:'20px',zIndex:1}}>
                        <div style={{
                            color:'black',
                            marginBottom:'min( 2svw, 2svh/1080*1920)',
                            fontSize:'min( 2svw, 2svh/1080*1920)',
                            fontWeight:'700',
                        }}>
                            Please enter your username and password
                        </div>
                        <input
                            value={username}
                            style={{
                                color:'black',
                                fontSize:'min( 2svw, 2svh/1080*1920)',
                                padding:'4px 8px',
                                borderRadius:'1px',
                                border:'1px solid #23FFF3',
                                minWidth:'45vw'
                            }}
                            placeholder='username'
                            onKeyDown={keyPressPWD}
                            onChange={(e)=>{setUsername(e.target.value)}}
                        />
                        <div style={{
                            color:'red',
                            fontSize:'min( 1.2svw, 1.2svh/1080*1920)',
                            padding:'2px 0px',
                            width:'100%',
                            textAlign:'left'
                        }}>{username_err}</div>


                        <input
                            value={password}
                            style={{
                                color:'black',
                                fontSize:'min( 2svw, 2svh/1080*1920)',
                                padding:'4px 8px',
                                borderRadius:'1px',
                                border:'1px solid #23FFF3',
                                minWidth:'45vw'
                            }}
                            placeholder='password'
                            onKeyDown={keyPressPWD}
                            onChange={(e)=>{setPassword(e.target.value)}}
                        />
                        <div style={{
                            color:'red',
                            fontSize:'min( 1.2svw, 1.2svh/1080*1920)',
                            padding:'2px 0px',
                            width:'100%',
                            textAlign:'left'
                        }}>{password_err}</div>
                        <div style={{
                            color:'black',
                            marginBottom:'20px',
                            fontSize:'min( 1.2svw, 1.2svh/1080*1920)',
                            fontWeight:'300',
                            width:'100%',
                            textAlign:'left',
                            marginTop:'min( 2svw, 2svh/1080*1920)',
                        }}>
                            * System will automatically create a new account if this is your first visit.
                        </div>
                        <div onClick={handleLogin}>
                            <StartBtnSvg width='180px'/>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
    
    return(
        <div style={{
            width:'100svw',
            height:'100vh',
            backgroundColor:'#D4D4D4',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexDirection:'column'
        }}> 
            <div style={{position:'absolute',zIndex:0}}>
                <LoginPageBgSvg width='100vw'/>
            </div>
            <div style={{backgroundColor:'white',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',padding:'20px',zIndex:1}}>
                <div style={{
                    color:'black',
                    marginBottom:'20px',
                    fontSize:22,
                    fontWeight:'700',
                }}>
                    Please enter your username and password
                </div>
                <input
                    value={username}
                    style={{
                        color:'black',
                        fontSize:'24px',
                        padding:'4px 12px',
                        borderRadius:'1px',
                        border:'1px solid #23FFF3',
                        minWidth:'45vw'
                    }}
                    placeholder='username'
                    onKeyDown={keyPressPWD}
                    onChange={(e)=>{setUsername(e.target.value)}}
                />
                <div style={{
                    color:'red',
                    fontSize:16,
                    padding:'2px 0px',
                    width:'100%',
                    textAlign:'left'
                }}>{username_err}</div>


                <input
                    value={password}
                    style={{
                        color:'black',
                        fontSize:'24px',
                        padding:'4px 12px',
                        borderRadius:'1px',
                        border:'1px solid #23FFF3',
                        minWidth:'45vw'
                    }}
                    placeholder='password'
                    onKeyDown={keyPressPWD}
                    onChange={(e)=>{setPassword(e.target.value)}}
                />
                <div style={{
                    color:'red',
                    fontSize:16,
                    padding:'2px 0px',
                    width:'100%',
                    textAlign:'left'
                }}>{password_err}</div>
                {/* <div style={{
                    width:200,
                    height:50,
                    backgroundColor:'#23FFF3',
                    borderRadius:24,
                    textAlign:'center',
                    justifyContent:'center',
                    alignItems:'center',
                    display:'flex',
                    marginTop:'20px',
                    fontSize:18,
                    fontWeight:'bold',
                    color:'white',
                    cursor:'pointer'
                }}
                    onClick={handleLogin}

                >
                    Start
                </div> */}
                <div style={{
                    color:'black',
                    marginBottom:'20px',
                    fontSize:16,
                    fontWeight:'300',
                    width:'100%',
                    textAlign:'left',
                    marginTop:10,
                }}>
                    * System will automatically create a new account if this is your first visit.
                </div>
                <div onClick={handleLogin}>
                    <StartBtnSvg width='200px'/>
                </div>
            </div>
            <div style={{position:'absolute',bottom:'1vw',left:'2vw'}}>
                <AquilaLogoSvg width='150px'/>
            </div>
        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  